// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useNavigate } from 'react-router-dom';

import {
  BackrsUser,
  setAccessToken,
  getAccessTokenOrCookie,
  handleAutoLogin,
  setCookie,
} from '@backrs_ui/common-ui';

import { APP_ROUTE } from '../App';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useAppDispatch } from '../redux/hooks';
import { setUser } from '../redux/user/user';
import { ENVIRONMENT, ENVIRONMENT_URL } from '../settings';

const isUnifiedLoginDisabled = process.env.REACT_APP_DISABLE_UNIFIED_LOGIN === 'true';

export const getBackrsToken = (): string | null => {
  return getAccessTokenOrCookie('backrs_ui_token', isUnifiedLoginDisabled);
};

type AfterLoginProps = Readonly<{
  access_token?: string;
  dispatch: ReturnType<typeof useAppDispatch>;
  navigate: ReturnType<typeof useNavigate>;
  setErrorMessage: (errorMessage: string) => void;
}>;

export const handleAfterLogin = async ({
  access_token,
  dispatch,
  navigate,
  setErrorMessage,
}: AfterLoginProps) => {
  if (access_token) {
    // so we know it was a success, we write access token to local storage
    setAccessToken('backrs_ui_token', access_token);
    setCookie(access_token, ENVIRONMENT);

    // now we can get the user info from DB
    const user: BackrsUser | null = await handleAutoLogin(access_token, ENVIRONMENT_URL);

    // if the user is null, we know something went wrong with authentication so we show the error
    if (!user) {
      setErrorMessage('Error getting user information');

      return;
    }

    dispatch(setUser(user));

    navigate(APP_ROUTE.HOME);
  }
};
